"use strict";
var ApiMessageType;
(function (ApiMessageType) {
    ApiMessageType[ApiMessageType["Validation"] = 0] = "Validation";
    ApiMessageType[ApiMessageType["PaymentInformation"] = 2] = "PaymentInformation";
    ApiMessageType[ApiMessageType["PolicyManagement"] = 3] = "PolicyManagement";
    ApiMessageType[ApiMessageType["Eligibility"] = 4] = "Eligibility";
    ApiMessageType[ApiMessageType["PartnerQuotes"] = 5] = "PartnerQuotes";
    ApiMessageType[ApiMessageType["Error"] = 6] = "Error";
    ApiMessageType[ApiMessageType["PreValid"] = 7] = "PreValid";
    ApiMessageType[ApiMessageType["Invoicing"] = 8] = "Invoicing";
    ApiMessageType[ApiMessageType["Agents"] = 9] = "Agents";
    ApiMessageType[ApiMessageType["Edit"] = 10] = "Edit";
    ApiMessageType[ApiMessageType["Authorization"] = 11] = "Authorization";
    ApiMessageType[ApiMessageType["Csv"] = 12] = "Csv";
    ApiMessageType[ApiMessageType["Recommendation"] = 13] = "Recommendation";
    ApiMessageType[ApiMessageType["DataBase"] = 14] = "DataBase";
    ApiMessageType[ApiMessageType["Override"] = 15] = "Override";
    ApiMessageType[ApiMessageType["Documents"] = 16] = "Documents";
    ApiMessageType[ApiMessageType["Address"] = 18] = "Address";
    ApiMessageType[ApiMessageType["Customer"] = 19] = "Customer";
})(ApiMessageType = exports.ApiMessageType || (exports.ApiMessageType = {}));
//# sourceMappingURL=D:/a/1/s/eligibility/src/models/api-message-type.enum.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/models/api-message-type.enum.js